import * as React from "react";
import usePromise from "../hooks/usePromise";
import { getEmployeeCommission } from "../../libs/commission_calculator";
import CommissionMonth from "./CommissionMonth";
import Loader from "../core/Loader";

function CommissionMonthContainer({ commissionMonthId, history, ...props }) {
  const [month, commissionPromise] = usePromise(() =>
    getEmployeeCommission(commissionMonthId)
  );

  const { loading } = commissionPromise;

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <CommissionMonth
          commission={month}
          commissionPromise={commissionPromise}
          history={history}
          {...props}
        />
      )}
    </>
  );
}

export default CommissionMonthContainer;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionMonthContainer.tsx